import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '../UI';

interface DeleteInterventionModalProps {
  interventionName: string;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}

export const DeleteInterventionModal = ({
  interventionName,
  onConfirm,
  onClose
}: DeleteInterventionModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      title={t('config-delete-intervention')}
      message={t('config-delete-template-message', { name: interventionName })}
      cancelLabel={t('config-delete-template-cancel')}
      confirmLabel={t('config-delete-template-confirm')}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
